import Vue from "vue"
import { BootstrapVue, IconsPlugin, ProgressPlugin } from "bootstrap-vue"
import VueApexCharts from "vue-apexcharts"
import App from "./App.vue"
import router from "./router"
import i18n from './i18n'
import store from "./store"
import VueSignaturePad from "vue-signature-pad"
import Vue2TouchEvents from "vue2-touch-events"
import browserDetect from "vue-browser-detect-plugin"


//import idb from "./include/idb";

import settings from "./include/settings";
import AppConfigClass from "./include/config";
import log from "./include/log";
import cfetch from "./include/cfetch";
import UserSession from "./include/usersession";
import users from "./include/users";
import DateTimeClass from "./include/datetime";
import stringhelper from "./include/stringhelper";
import './registerServiceWorker'

//Vue.prototype.$idb = idb;
Vue.prototype.$settings = settings;
Vue.prototype.$config = new AppConfigClass();
Vue.prototype.$log = log;
Vue.prototype.$cfetch = cfetch;
Vue.prototype.$UserSession = UserSession;
Vue.prototype.$users = users;
Vue.prototype.$datetime = new DateTimeClass(i18n);
Vue.prototype.$stringhelper = stringhelper;

Vue.config.productionTip = false;

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(ProgressPlugin);
Vue.use(VueSignaturePad);
Vue.use(Vue2TouchEvents);
Vue.use(browserDetect);

Vue.component("apexchart", VueApexCharts);
Vue.component("UserSession", UserSession);

//Forms
import CheckboxInput from '/src/components/Inputs/CheckboxInput';
Vue.component("CheckboxInput", CheckboxInput);
import SelectInput from '/src/components/Inputs/SelectInput';
Vue.component("SelectInput", SelectInput);
import SelectSearchInput from '/src/components/Inputs/SelectSearchInput';
Vue.component("SelectSearchInput", SelectSearchInput);
import MultiselectSearchInput from '/src/components/Inputs/MultiselectSearchInput';
Vue.component("MultiselectSearchInput", MultiselectSearchInput);
import TextInput from './components/Inputs/TextInput';
Vue.component("TextInput", TextInput);
import TextAreaInput from './components/Inputs/TextAreaInput';
Vue.component("TextAreaInput", TextAreaInput);
import TextAreaAutosize from './components/Inputs/TextAreaAutosize';
Vue.component("TextAreaAutosize", TextAreaAutosize);

// Legacy support for textarea-autosize
import PluginTextareaAutosize from 'vue-textarea-autosize';
Vue.use(PluginTextareaAutosize);

/*
*/


/*
window.isUpdateAvailable = function() {
	console.log('updating');
    window.location.reload();
};
function updateapp(event) {
    window.location.reload();
}
window.applicationCache.addEventListener('updateready', updateSite, false);
*/

function isValidLocale(locale) {
	return Object.prototype.hasOwnProperty.call(settings.languages, locale);
}

function getLocaleFromNavigatorLanguage() {
	if(navigator.language){
		if(navigator.language in settings.languages){
			return navigator.language;
		}
		for (var key in settings.languages) {
			if(settings.languages[key].match.includes(navigator.language)) {
				return key
			}
		}
	}
	return false;
}

const layer = new Vue({
	router,
	i18n,
	store,
	render: (h) => h(App)
});

if ("cordova" in window) {

	document.addEventListener('deviceready', function() {

		router.onReady(()=>{
			layer.$mount("#app")
		});

		if(isValidLocale(localStorage.getItem('locale'))) { // user-specified
			i18n.locale = localStorage.getItem('locale');
		} else if(getLocaleFromNavigatorLanguage()) { // provided by browser
			i18n.locale = getLocaleFromNavigatorLanguage();
		} else { // appTarget fallback
			i18n.locale = settings.fallbackLocale;
		}

	});

	document.addEventListener('resume', function() {

		//notifications.handleNotifications();

	});

} else {


	router.onReady(()=>{
		layer.$mount("#app")
	});
	/*	new Vue({
			router,
			i18n,
			store,
			render: (h) => h(App)
		}).$mount("#app");*/

	if(isValidLocale(localStorage.getItem('locale'))) { // user-specified
		i18n.locale = localStorage.getItem('locale');
	} else if(getLocaleFromNavigatorLanguage()) { // provided by browser
		i18n.locale = getLocaleFromNavigatorLanguage();
	} else { // appTarget fallback
		i18n.locale = settings.fallbackLocale;
	}

}
